import { Component, OnInit, Injector } from '@angular/core';
import { WorkOrdersService } from '../../../work-orders.service';
import { BannerService } from '../../../../ve.service';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'ga-header-message-form',
  templateUrl: './ga-header-message-form.component.html',
  styleUrls: ['./ga-header-message-form.component.scss', '../../../work-orders.component.scss', '../../../../../ve/ve.component.scss']
})
export class GaHeaderMessageFormComponent implements OnInit {
  workOrdersService: WorkOrdersService;
  bannerService: BannerService;
  headerMessage: SafeHtml;

  constructor(injector: Injector, private readonly sanitizer: DomSanitizer) {
    this.workOrdersService = injector.get(WorkOrdersService);
    this.bannerService = injector.get(BannerService);
  }

  ngOnInit() {
    this.getHeaderMessage();
  }

  getHeaderMessage() {
    this.bannerService.loading.next(true);
    this.bannerService.read('/Module/VE_GA')
      .then(response => {
        this.headerMessage = this.sanitizer.bypassSecurityTrustHtml(response.Message);
        this.bannerService.loading.next(false);
      });
  }

}
